import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { Service } from './../models/index';
import { Resolve } from '@angular/router';

@Injectable()
export class ServiceService implements Resolve<Service[]> {
  constructor(
    private apiCallService: ApiCallService
  ) { }

  getServices(): Promise<Service[]> {
    return this.apiCallService.get('/services');
  }

  resolve(): Promise<Service[]> {
    return this.getServices();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/service.service.ts